export enum IceWidgetGroupsEnum {
    CONTENT_SCORES = 'ContentScores',
    IMAGE_TRACKER = 'ImageTracker',
    LISTING_STATUS = 'ListingStatus',
    MISCELLANEOUS = 'Miscellaneous',
    HISTORY = 'History',
}
